export default "__VITE_PUBLIC_ASSET__f94ba502__"